// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal{border-radius:6px;overflow:auto;background:rgba(34,34,34,0.2);border-radius:0;display:block;position:fixed;top:0;left:0;height:100vh;width:100vw;box-sizing:border-box;padding:60px;z-index:100}.modal .block{margin:auto;max-width:70rem;padding:40px 50px}.modal.medium .block{max-width:60rem}.modal.small .block{margin:auto;max-width:45rem}.modal .close-modal{float:right;margin:-10px -20px 0 0;cursor:pointer}\n", ""]);
// Exports
module.exports = exports;
